import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installFirmSession } from './auth/firmSession';
import { installClientSession } from './auth/clientSession';
import { initializeSessionVault } from './mobile/sessionVault';
import { installNativeFileHandling } from './mobile/nativeFiles';

const root = ReactDOM.createRoot(document.getElementById('root'));
async function start() {
  try {
    await initializeSessionVault();
    installFirmSession();
    installClientSession();
    installNativeFileHandling();
    root.render(<App />);
  } catch {
    root.render(<main style={{ padding: 32 }}><h1>Secure sign-in is unavailable</h1><p>Restart the app to unlock its secure storage.</p><button onClick={() => window.location.reload()}>Try again</button></main>);
  }
}
start();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
